export const MerchantAliases = {
  ObelisBrazil: 'obelisbrazil',
  ObelisBrazilStage: 'obelisbrazilstage',
  TestMerchantPaylands: 'testmerchantpaylands',
};

export type MerchantAlias = (typeof MerchantAliases)[keyof typeof MerchantAliases];
